import React from 'react'

const Error = (props) => {
  return (
    <div>
      <span className="error-message">
        {props.error && props.error.required &&
          <span>{props.setting.requiredMessage || `${props.setting.label} is required.`} </span>
        }

        {props.error && props.error.min &&
          <span>{props.setting.minMessage || `Minimum number must be ${props.setting.min}.`} </span>
        }

        {props.error && props.error.max &&
          <span>{props.setting.maxMessage || `Maximum number must be ${props.setting.max}.`} </span>
        }

        {props.error && props.error.minLength &&
          <span>{props.setting.minLengthMessage || `${props.setting.label} must be at least ${props.setting.minLength} characters long.`} </span>
        }

        {props.error && props.error.maxLength &&
          <span>{props.setting.maxLengthMessage || `${props.setting.label} can be max ${props.setting.maxLength} characters long.`} </span>
        }

        {props.error && props.error.pattern &&
          <span>{props.setting.patternMessage || `Please enter a valid ${props.setting.label}.`} </span>
        }

        {props.error && props.error.uploadRequired &&
          <span>{props.setting.uploadMessage || `Please upload ${props.setting.label}.`} </span>
        }

        {props.error && props.error.fileSizeError &&
          <span>{props.setting.fileSizeErrorMessage || `File size cannot be more than ${props.setting.fileSize} MB.`} </span>
        }

        {props.error && props.error.upto2Digit &&
          <span>{props.setting.upto2DigitMessage || `Decimal value allowed up to 2 digit`} </span>
        }

        {props.error && props.error.upto3Digit &&
          <span>{props.setting.upto3DigitMessage || `Decimal value allowed up to 3 digit`} </span>
        }

        {props.error && props.error.upto4Digit &&
          <span>{props.setting.upto4DigitMessage || `Decimal value allowed up to 4 digit`} </span>
        }

        {props.error && props.error.decimalOnly &&
          <span>{props.setting.decimalOnlyMessage || `Decimal value not allowed`} </span>
        }

        {props.error && props.error.zeroNotAllowed &&
          <span>{props.setting.zeroNotAllowMessage || `Minimum number must be 0.001`} </span>
        }

        {props.error && props.error.space && Object.keys(props.error).length == 1 &&
          <span>{props.setting.spaceMessage || `Space not allowed before and after ${props.setting.label}.`} </span>
        }
        {props.error && props.error.customError &&
          <span>{props.setting.customErrorMessage} </span>
        }

        {props.error && props.error.ioBudgetNullError &&
          <span>{props.setting.ioBudgetNullErrorMessage} </span>
        }

      </span>
    </div>
  )
}
export default Error;
